import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
} from "@mui/material";

type AccountOrVaultIdFieldProps = {
  property: string;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  vaults: { id: string; name: string }[];
  accounts: { id: string; accountName: string }[];
};

export const AccountOrVaultIdField = ({ property, value, onChange, vaults, accounts }: AccountOrVaultIdFieldProps) => {
  return (
    <FormControl>
      <InputLabel>{property}</InputLabel>
      <Select value={value} onChange={onChange} label={property} input={<OutlinedInput label={property} />}>
        {property === "vaultId" &&
          vaults.map((vault) => (
            <MenuItem key={vault.id} value={vault.id}>
              {vault.name} - {vault.id}
            </MenuItem>
          ))}
        {property === "accountId" &&
          accounts.map((account) => (
            <MenuItem key={account.id} value={account.id}>
              {account.accountName} - {account.id}
            </MenuItem>
          ))}
      </Select>
      <FormHelperText>String</FormHelperText>
    </FormControl>
  );
};
